import React from 'react'

export default class TermAccordion extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
        open: false
    }
  }

  toggleTermAccordion = e => {

  }

  render() {
      return (
        <div className="term-accordion-wrap">
          <div className={['term-accordion', this.state.open ? 'term-accordion--open' : ''].join(' ')} onClick={e => this.setState({ open: !this.state.open })}>
            <div className="term-accordion-title">
              {this.props.title}
            </div>
            <div className="term-accordion-content">
              {this.props.children}
            </div>
          </div>
        </div>
      );
  }
}